<template>
    <div>
        <el-menu :default-active="lastActive" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item v-for="(item,index) in prop" :key="index" :index="index.toString()">{{ item.title }}  {{ item.num }}</el-menu-item>
        </el-menu>
    </div>
</template>

<script>
  export default {
    props: ['prop'],
    data() {
      return {
        activeIndex: '0',
        lastActive: '0'
      };
    },
    methods: {
      handleSelect(keyPath) {
        console.log("keyPath",keyPath);
        if(keyPath != this.lastActive) {
          const findItem = this.prop[keyPath];
          this.$emit('func', findItem)
          this.lastActive = keyPath
        }
      }
    }
  }
</script>